<div class="layers-panel">
    <div class="panel-header">
        <h3 class="panel-title">Layers</h3>
        <span class="layer-count">{{ objects().length }}</span>
    </div>

    <div class="layers-list">
        @if (objects().length === 0) {
            <div class="empty-state">
                <p>No layers yet</p>
                <small>Create shapes using the tools</small>
            </div>
        } @else {
            @for (obj of sortedObjects(); track obj.id) {
                <div
                    class="layer-item"
                    [class.selected]="isSelected(obj.id)"
                    [class.hidden]="!obj.visible"
                    [class.locked]="obj.locked"
                    (click)="selectLayer(obj.id, $event)">
                    <div class="layer-icon">{{ getIcon(obj.type) }}</div>
                    <div class="layer-info">
                        <div class="layer-name">{{ obj.name }}</div>
                        <div class="layer-type">{{ obj.type }}</div>
                    </div>
                    <div class="layer-actions">
                        <button
                            class="layer-action-btn"
                            [class.active]="obj.visible"
                            (click)="toggleVisibility(obj.id, $event)"
                            [title]="obj.visible ? 'Hide' : 'Show'">
                            {{ obj.visible ? '👁️' : '👁️‍🗨️' }}
                        </button>
                        <button
                            class="layer-action-btn"
                            [class.active]="obj.locked"
                            (click)="toggleLock(obj.id, $event)"
                            [title]="obj.locked ? 'Unlock' : 'Lock'">
                            {{ obj.locked ? '🔒' : '🔓' }}
                        </button>
                    </div>
                </div>
            }
        }
    </div>

    @if (objects().length > 0) {
        <div class="layer-controls">
            <button
                class="control-button"
                (click)="duplicateLayer()"
                [disabled]="!hasSelection()"
                title="Duplicate Layer">
                📋
            </button>
            <button
                class="control-button"
                (click)="deleteLayer()"
                [disabled]="!hasSelection()"
                title="Delete Layer">
                🗑️
            </button>
            <button
                class="control-button"
                (click)="moveUp()"
                [disabled]="!hasSelection()"
                title="Move Up">
                ⬆️
            </button>
            <button
                class="control-button"
                (click)="moveDown()"
                [disabled]="!hasSelection()"
                title="Move Down">
                ⬇️
            </button>
        </div>
    }
</div>
